import type { MisconceptionDefinition } from './types';
import { basisSamenstellingTremaMisconceptions } from './spr/basisSamenstellingTrema';
import { latijnGrieksCMisconceptions } from './spr/latijnGrieksC';
import { klankHoofdletterLeestekenMisconceptions } from './spr/klankHoofdletterLeesteken';
import { fransLeenwoordenMisconceptions } from './spr/fransLeenwoorden';
import { verdubbelingJagerMisconceptions } from './spr/verdubbelingJager';
import { klankOverigeDtMisconceptions } from './spr/klankOverigeDt';

/**
 * SPR — Spelling regels misconcepties (barrel).
 *
 * Deze barrel concateneert zes sub-registries onder `./spr/`:
 * - `basisSamenstellingTrema`
 * - `latijnGrieksC`
 * - `klankHoofdletterLeesteken`
 * - `fransLeenwoorden`
 * - `verdubbelingJager`
 * - `klankOverigeDt`
 */
export const SPR_MISCONCEPTIONS: MisconceptionDefinition[] = [...basisSamenstellingTremaMisconceptions, ...latijnGrieksCMisconceptions, ...klankHoofdletterLeestekenMisconceptions, ...fransLeenwoordenMisconceptions, ...verdubbelingJagerMisconceptions, ...klankOverigeDtMisconceptions];